import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Router, Switch, Route } from 'react-router-dom'
import history from './history'
import Helmet from 'react-helmet'
import { Provider, connect } from 'react-redux'
import configureStore from './store'
import registerServiceWorker from './registerServiceWorker'
import './style/index.css'
import { resizing, fetchToken, fetchUser } from './actions'
const store = configureStore({}) 

import MainLayout from './routes/MainLayout'

class App extends React.Component<any, {}> {

    private resizeTimeout: any

    componentDidMount() {
        this.props.fetchToken()
        this.props.fetchUser()
        this.props.resizing(window.innerWidth)

        window.addEventListener('resize', this.resizeThrottler, true)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeThrottler, true)
    }

    resizeThrottler = () => {
        if ( !this.resizeTimeout ) {
            this.resizeTimeout = setTimeout(() => {
                this.resizeTimeout = null
                this.props.resizing(window.innerWidth)
            }, 1000)
        }
    }

    render() {
        return (
            <div>
                <Helmet 
                    title="六度智囊"
                    meta={[
                        { name: 'keywords', content: '六度智囊' },
                        { name: 'description', content: '六度智囊' }
                    ]}
                />
                <Switch>
                    <Route path="/" component={MainLayout} />
                </Switch>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        width: state.width,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchToken: () => dispatch(fetchToken()),
        fetchUser: () => dispatch(fetchUser()),
        resizing: (width: number) => dispatch(resizing(width)),
    }
}

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Route component={connect(mapStateToProps, mapDispatchToProps)(App)} />
        </Router>
    </Provider>, 
    document.getElementById('root') as HTMLElement
)

registerServiceWorker()


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx